import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { getUserGroup } from '@/utils';
import ForgotPassword from '../views/ForgotPassword/index.vue';
import Login from '../views/Login/index.vue';
import NotFound from '../views/NotFound/index.vue';
import Start from '../views/Start/index.vue';
import AdminHome from '../views/Admin/Home/index.vue';
import FrigHome from '../views/Frig/Home/index.vue';
import AdminProdDetails from '../views/TerritoryDetails/index.vue';
import FrigDetails from '../views/Frig/Details/index.vue';
import Calender from '../components/CalenderComponent/index.vue';
import Geomonitoramento from '../components/Geomonitoramento/index.vue';
import Autovistoria from '../views/Monitoring/Autovistoria/index.vue';
import Ticket from '../views/Monitoring/Tickets/index.vue';
import Monitoring from '../views/Monitoring/index.vue';
import Question from '../views/Monitoring/Question/index.vue';
import NewHomeProd from '../views/Producer/NewHome/index.vue';
import PayPix from '../views/Producer/PayPix/index.vue';
import AdminContestation from '../views/TerritoryContestation/index.vue';
import PaymentPay from '../views/Admin/PaymentPayValue/index.vue';
import PenaltyPage from '../views/Admin/Penalty/index.vue';
import DetailsPay from '../views/TerritoryDetailsPay/index.vue';
import Voucher from '../views/Frig/Voucher/index.vue';
import Profile from '../views/Profile/index.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Login,
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/comecar-agora',
    name: 'Start',
    component: Start,
  },
  {
    path: '/admin/territorioPay/:id/:paymentMet',
    name: 'Details Pay',
    component: DetailsPay,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminHome,
  },
  {
    path: '/produtor/paymentPay/:paymentValue/:installments/:documentData/:id ',
    name: 'PaymentPay',
    component: PaymentPay,
  },
  {
    path: '/esqueci-minha-senha',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/admin/multa/:id',
    name: 'Penalty',
    component: PenaltyPage,
  },
  {
    path: '/frigorifico',
    name: 'Frig',
    component: FrigHome,
  },
  {
    path: '/admin/territorioInfo/:id/:name/:document',
    name: 'Admin Details',
    component: AdminContestation,
  },
  {
    path: '/paypix/:id',
    name: 'PayPix',
    component: PayPix,
  },
  {
    path: '/produtor',
    redirect: '/produtor/territory',
    component: NewHomeProd,
    children: [
      {
        path: 'territory',
        component: () => import('../views/Producer/NewHome/Territory/index.vue'),
        children: [
          {
            path: '',
            component: () => import('../views/Producer/NewHome/Territory/List/index.vue'),
          },
          {
            path: ':id/:name',
            component: () => import('../views/Producer/NewHome/Territory/Details/index.vue'),
            name: 'ProdDetails',
            props: true,
          },
        ],
      },
      {
        path: 'calendar',
        component: () => import('../views/Producer/NewHome/Calendar/index.vue'),
      },
      {
        path: '/paypix1/:id',
        component: () => import('../views/Producer/PayPix/index.vue'),
        name: 'PayPixInfo',
        props: true,
      },
      {
        path: '/UserProfile',
        component: () => import('../views/Profile/index.vue'),
        name: 'UserProfile',
        props: true,
      },
      {
        path: '/produtor/paymentPay/:paymentValue/:installments/:documentData/:id/:contastation',
        component: () => import('../views/Admin/PaymentPayValue/index.vue'),
        name: 'PaymentPayInfo',
        props: true,
      },
      {
        path: 'payments',
        component: () => import('../views/Producer/NewHome/Payment/index.vue'),
      },
      {
        path: 'register-territory',
        component: () => import('../views/Producer/NewHome/RegisterTerritory/index.vue'),
      },
    ],
  },
  {
    path: '/admin/territorio/:id',
    name: 'Admin Details',
    component: AdminProdDetails,
  },
  {
    path: '/frigorifico/territorio/:id/:name',
    name: 'Frig Details',
    component: FrigDetails,
  },
  {
    path: '/voucher',
    name: 'voucher',
    component: Voucher,
  },
  {
    path: '/produtor/territorio/:id/:name',
    name: 'Prod Details',
    component: AdminProdDetails,
    props: true,
    meta: {
      bradcrumb: 'Detalhes',
    },
  },
  {
    path: '/calender',
    name: 'Calender',
    component: Calender,
    meta: {
      bradcrumb: 'Calendário',
    },
  },
  {
    path: '/UserProfile',
    name: 'UserProfile',
    component: Profile,
  },
  {
    path: '/monitoring',
    component: Monitoring,
    children: [
      {
        name: 'Geomonitoramento',
        path: '',
        props: true,
        component: Geomonitoramento,
        meta: {
          bradcrumb: 'Geomonitoramento',
        },
      },
      {
        path: 'autovistoria',
        name: 'Autovistoria',
        props: true,
        component: Autovistoria,
        meta: {
          bradcrumb: 'Autovistoria',
        },
      },
      {
        path: 'ticket',
        name: 'Ticket',
        props: true,
        component: Ticket,
        meta: {
          bradcrumb: 'Ticket',
        },
      },
      {
        path: 'autovistoria/question/:cdEvidence',
        component: Question,
        name: 'Question',
        props: true,
        meta: {
          name: 'Questionário',
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const userLogged = sessionStorage.getItem('userLogged');
  const validRouteFrom = from.path.includes('frig') || from.path.includes('produtor') || from.path.includes('admin');
  const validRouteTo = to.path.includes('frig') || to.path.includes('produtor') || to.path.includes('admin');
  const type = getUserGroup();

  const initialRoutes = ['/', '/login', '/comecar-agora', '/esqueci-minha-senha'];

  if (initialRoutes.includes(to.path)) {
    if (!userLogged) next();
    next({
      path: type as string,
    });
  } else if (!userLogged) {
    next({
      path: '/login',
    });
  } else if (
    (validRouteTo && to.path.split('/')[1] !== type)
    || (validRouteFrom && from.path.split('/')[1] !== type)
    || !to.matched.length
  ) {
    next({
      path: '/not-found',
    });
  } else next();
});

export default router;
